import React, { memo } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import Text from '../../ui/Text'
import { ChargePoint } from '../../common/redux/api/web-api'

export type ChargePointFavoritesDashboardWidgetProps = {
    favourites?: ChargePoint[]
    style?: React.CSSProperties
}

const SLink = styled.a`
    & {
        color: ${({ theme }) => theme.font.darkestColor};
        text-decoration: underline;
        text-underline-offset: 5px;
        font-weight: 400;
        line-height: 30px;
    }

    &:hover {
        color: ${({ theme }) => theme.font.successColor};
        cursor: pointer;
    }

    &:active {
        color: ${({ theme }) => theme.font.midDarkColor};
    }
`

export const ChargePointFavoritesDashboardWidget = memo(function ChargePointFavoritesDashboardWidget({
    style,
    favourites,
}: ChargePointFavoritesDashboardWidgetProps): React.ReactElement {
    return (
        <div className="widget" style={style}>
            <div className="widget-report widget-header">
                <Text code="lblFavourites"></Text>
            </div>
            <div className="dashboard-widget">
                <div>
                    <div>
                        {favourites?.map((favorite) => (
                            <div key={favorite.id}>
                                <SLink as={Link} data-testid="chargePoint-id" to={`/chargepoints/${favorite.id}`}>
                                    {favorite.chargePointStatus == 'Offline' ? (
                                        <span data-testid="offline" className="fa fa-circle redFont padding-4"></span>
                                    ) : (
                                        <span
                                            data-testid="online"
                                            className="fa fa-circle availableGreenFont padding-4"
                                        ></span>
                                    )}
                                    {favorite.id}
                                </SLink>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
})
